import api from "./Api";

class PedidoClienteService {
  GetPedidoCliente(payload) {
    return api.get("/v1/pedidoCliente/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoCliente(payload) {
    return api.post("/v1/pedidoCliente/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoCliente(payload) {
    return api.put("/v1/pedidoCliente/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoCliente(payload) {
    return api.delete("/v1/pedidoCliente/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoClienteOData(payload) {
    return api.get("/OData/PedidoCliente" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PedidoClienteService();
